import { gql } from '@web/federation/gql'

export const MissionSectionQuery = gql(`
  query MissionSection {
    ...MissionSection_Query
  }

  fragment MissionSection_Query on Query {
    currentMissionSummaries {
      ... on CurrentMissionSummariesSucceed {
        missionSummaries {
          id
          name
          stampName
          stampCount
          stampCountToComplete
          imageUrl
          borderImageUrl
          detailUrl
        }
        dday
        startDateTime
        endDateTime
        isParticipating
      }
    }
  }
`)
